/**
 * JavaScript-side view of the design tokens.
 *
 * Values reference CSS custom properties rather than duplicating hex codes, so
 * tokens.css remains the single source of truth and dark mode applies
 * automatically. A hard-coded hex here would silently break theming.
 */

export const CARD_LABEL_COLOURS = [
  { id: 'green', name: 'Green', cssVar: 'var(--color-label-green)' },
  { id: 'teal', name: 'Teal', cssVar: 'var(--color-label-teal)' },
  { id: 'blue', name: 'Blue', cssVar: 'var(--color-label-blue)' },
  { id: 'violet', name: 'Violet', cssVar: 'var(--color-label-violet)' },
  { id: 'purple', name: 'Purple', cssVar: 'var(--color-label-purple)' },
  { id: 'magenta', name: 'Magenta', cssVar: 'var(--color-label-magenta)' },
  { id: 'crimson', name: 'Crimson', cssVar: 'var(--color-label-crimson)' },
  { id: 'orange', name: 'Orange', cssVar: 'var(--color-label-orange)' },
  { id: 'gold', name: 'Gold', cssVar: 'var(--color-label-gold)' },
  { id: 'slate', name: 'Slate', cssVar: 'var(--color-label-slate)' },
] as const;

export type CardLabelColourId = (typeof CARD_LABEL_COLOURS)[number]['id'];

export const CARD_LABEL_COLOUR_IDS = CARD_LABEL_COLOURS.map((colour) => colour.id);

export function labelColourVar(id: CardLabelColourId): string {
  const match = CARD_LABEL_COLOURS.find((colour) => colour.id === id);
  return match ? match.cssVar : 'var(--color-label-slate)';
}

/** Elevation levels, exposed for components that set shadows programmatically. */
export const ELEVATION = {
  e1: 'var(--shadow-e1)',
  e2: 'var(--shadow-e2)',
  e3: 'var(--shadow-e3)',
  e4: 'var(--shadow-e4)',
} as const;

export const DURATION = {
  micro: 150,
  standard: 200,
  modal: 300,
} as const;

/** Z-index scale — so nobody ever writes `z-index: 9999` again. */
export const Z_INDEX = {
  dropdown: 1000,
  sticky: 1010,
  drawer: 1020,
  modal: 1030,
  popover: 1040,
  toast: 1050,
  tooltip: 1060,
} as const;
